export default "data:image/webp;base64,UklGRkoAAABXRUJQVlA4TD0AAAAvJ4AGAFATAAmTjChEkRKmMKXfOvkUBCCAWGmOPz6WggAgkE+aY/1d/yeg/3M1EXg0W7opeVwUT4j7gPsLAA=="